'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _renderprops = require('react-spring/renderprops');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var number = [{
    value: 0,
    active: [0, 1, 2, 4, 5, 6]
}, {
    value: 1,
    active: [2, 6]
}, {
    value: 2,
    active: [1, 2, 3, 4, 5]
}, {
    value: 3,
    active: [1, 2, 3, 5, 6]
}, {
    value: 4,
    active: [0, 2, 3, 6]
}, {
    value: 5,
    active: [0, 1, 3, 5, 6]
}, {
    value: 6,
    active: [0, 1, 3, 4, 5, 6]
}, {
    value: 7,
    active: [1, 2, 6]
}, {
    value: 8,
    active: [0, 1, 2, 3, 4, 5, 6]
}, {
    value: 9,
    active: [0, 1, 2, 3, 5, 6]
}];

var lineArray = ['40,40 60,60 80,80 80,160 40,180 40,150', '40,37 83,37 190,37 170,57 150,77 80,77', '150,80 190,40 190,80 190,160 190,180 150,160', '40,183 80,162 150,162 190,182 150,204 80,204', '40,185 40,185 80,206 80,287  40,327 40,287', '40,330 80,290 150,290 190,330 187,330 80,330', '150,206 190,184 190,207 190,287  190,327 150,287'];

var DigitalNumber = function DigitalNumber(_ref) {
    var nums = _ref.nums,
        _ref$width = _ref.width,
        width = _ref$width === undefined ? "100%" : _ref$width,
        _ref$height = _ref.height,
        height = _ref$height === undefined ? "100%" : _ref$height,
        _ref$color = _ref.color,
        color = _ref$color === undefined ? "#FF0000" : _ref$color,
        _ref$unActiveColor = _ref.unActiveColor,
        unActiveColor = _ref$unActiveColor === undefined ? "#22221e" : _ref$unActiveColor,
        _ref$backgroundColor = _ref.backgroundColor,
        backgroundColor = _ref$backgroundColor === undefined ? "#000" : _ref$backgroundColor,
        _ref$transition = _ref.transition,
        transition = _ref$transition === undefined ? 'none' : _ref$transition,
        _ref$transform = _ref.transform,
        transform = _ref$transform === undefined ? false : _ref$transform,
        _ref$transformDuratio = _ref.transformDuration,
        transformDuration = _ref$transformDuratio === undefined ? 600 : _ref$transformDuratio;

    var numsArray = nums ? nums.split('') : [1, 2, 3];
    numsArray = numsArray.filter(function (item) {
        return (/[0-9]/g.test(item)
        );
    });
    // const props = useSpring({ number: 1, from: { number: 0 } })
    return _react2.default.createElement(
        'div',
        {
            style: {
                background: backgroundColor,
                display: 'flex',
                width: width,
                height: height,
                transition: transition ? transition : 'none'
            }
        },
        numsArray.map(function (item, index) {
            return _react2.default.createElement(
                _renderprops.Spring,
                {
                    key: item + '-' + index,
                    from: { number: 0 },
                    to: { number: parseInt(item, 10) },
                    config: { duration: transformDuration }
                },
                function (props) {
                    return _react2.default.createElement(
                        'svg',
                        {
                            xmlns: 'http://www.w3.org/2000/svg',
                            viewBox: '0 0 228 376',
                            width: '100%',
                            height: '100%',
                            xmlnsXlink: 'http://www.w3.org/1999/xlink'
                        },
                        _react2.default.createElement(
                            'g',
                            null,
                            lineArray.map(function (line, lineIndex) {
                                return _react2.default.createElement('polygon', {
                                    key: line,
                                    points: line,
                                    style: { fill: number[transform ? Math.ceil(props.number) : item].active.includes(lineIndex) ? color : unActiveColor }
                                });
                            })
                        )
                    );
                }
            );
        })
    );
};
// Render app
exports.default = DigitalNumber;